<template>
  <div class="benefits icon-grid">
    <div class="container">
      <h2 class="center">Why Grass-Fed?</h2>
      <r-grid columns="4" columns-l="8" columns-s="2">
        <r-cell span="2">
          <i class="fad fa-steak fa-4x mb-16 salmon"></i>
          <h5 class="salmon">Healthier, higher quality meat</h5>
          <p>
            Food from animals that are grass-fed is healthier and more
            nutrient-rich for us to eat than meat produced from grain-fed cattle
            - and also tastes better!
          </p>
        </r-cell>
        <r-cell span="2">
          <i class="fad fa-cow fa-4x mb-16 charcoal"></i>
          <h5 class="charcoal">Grass is better for animals</h5>
          <p>
            There is a lot of scientific research that shows animals fed on
            grass are less stressed, live longer and are more fertile than those
            farmed intensively.
          </p>
        </r-cell>
        <r-cell span="2">
          <i class="fad fa-globe-europe fa-4x mb-16 blue"></i>
          <h5 class="blue">Good for the environment</h5>
          <p>
            Grass-fed farms often have a positive carbon footprint, by regenerating the soil rather than depleting it, and supporting
            more wildlife.
          </p>
        </r-cell>
        <r-cell span="2">
          <i class="fad fa-hand-holding-seedling fa-4x mb-16 green"></i>
          <h5 class="green">Utilises local resources</h5>
          <p>
            Grass is an often under utilised crop in the UK. There is a lot of
            potential to produce more food from our grassland, reducing the need
            to import feeds.
          </p>
        </r-cell>

        <r-cell span="2+2" span-l="4+2" span-s="row">
          <a class="btn btn-outline w-100" href="/why-grass-fed">Read more</a>
        </r-cell>
      </r-grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "Benefits"
};
</script>

<style lang="scss" scoped>
@import "@/global-styles/variables.scss";

h5 {
  margin-top: $spacing-2;
}
</style>
